import PropTypes from 'prop-types';
import React from 'react';

const AspectImage = ({ imgSrc, title, className, smallImgSrc }) => {
  const baseStyles = 'h-full w-full aspect-[390/400] object-cover lg:aspect-[1312/776]';

  if (smallImgSrc) {
    return (
      <picture>
        <source srcSet={imgSrc} media="(min-width: 1024px)" />
        <img src={smallImgSrc} alt={title} className={`${baseStyles} ${className}`} />
      </picture>
    );
  }
  return <img src={imgSrc} alt={title} className={`${baseStyles} ${className}`} />;
};

AspectImage.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  smallImgSrc: PropTypes.string,
};

AspectImage.defaultProps = {
  className: '',
  smallImgSrc: null,
};
export default AspectImage;
